import { Component, OnInit } from '@angular/core';
import swal from 'sweetalert2';
import { ActivatedRoute, Router } from '@angular/router';
import { SecurityHelper } from '../pages/common/securityHelper';
import { ShipCrewData } from '../pages/maintenance/model/ship-crew-data';
import { ShipCrewService } from '../pages/maintenance/ship-crew/ship-crew.service';
import { SecurityService } from '../pages/security/service/security.service';
import { OnlineOfflineService } from '../services/online-offline.service';
import { NgbCarouselConfig } from '@ng-bootstrap/ng-bootstrap';
import { HomeService } from './home.service';
import { ContentDetailData } from '../pages/common/model/ContentDetailData';
import { DataFormatter } from '../pages/common/dataFormatter';
import { WebStorage } from '../pages/common/webStorage';
import { Helper } from '../pages/common/helper';
import { DailyLogsService } from '../services/daily-logs.service';


@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.scss'],
  providers: [NgbCarouselConfig]
})
export class HomeComponent implements OnInit {
  public logoPath!: string;
  userName!: string;
  shipCrewList: ShipCrewData[] = [];
  allCrewList: ShipCrewData[] = [];
  captainList: ShipCrewData[] = [];
  campbossList: ShipCrewData[] = [];
  cookList: ShipCrewData[] = [];
  countAPIRetry: number = 0;
  shipId!: number;
  shipsManagerOwnerID!: number;
  unableToLoadImage: boolean = false;
  contentCategoryList: any[] = [];
  ReminderAnnouncement: any[] = [];
  contenDetailList: ContentDetailData[] = [];
  contenDetail: ContentDetailData = new ContentDetailData();
  contenDocumentList: any[] = [];
  contentImageFileUrl!: string;
  contentFeatures: boolean = true;
  allowContentFeatures: boolean = true;
  contenFeatureDetailList: any[] = [];
  contentDisplayMore: boolean = false;

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private shipCrewService: ShipCrewService,
    public readonly onlineOfflineService: OnlineOfflineService,
    private securityService: SecurityService,
    private homeService: HomeService,
    config: NgbCarouselConfig,
    private dailyLogsService: DailyLogsService,
  ) {
    config.interval = 7000;
    config.keyboard = true;
    config.pauseOnHover = true;
    config.showNavigationIndicators = false;
    config.showNavigationArrows = false;
  }
  ngOnInit() {

    if (!SecurityHelper.GetLightVersion()) {
      this.createLogs(Helper.Constants.DailyLogs.Forms.HOME
        ,Helper.Constants.DailyLogs.Actions.PAGE_VIEW
        ,Helper.Constants.DailyLogs.Results.SUCCESSFUL
        ,"IVI View " + Helper.Constants.DailyLogs.Forms.HOME
        , Helper.Constants.DailyLogs.MainTableNames.CONTENT_DETAILS)
    }
    let userData = SecurityHelper.GetLoggedInUserData();
    this.shipId = userData.shipID;
    this.getShipManagerLogoDirectoryPath();

    let params = JSON.parse(WebStorage.SessionStorage.GetQueryParams());
    if (params && params['Id'] != null) {
      let contentCategoryId = params['Id'];
      this.contentFeatures = false;
      this.contentDisplayMore = false;
      this.getContentDetailList(contentCategoryId);

      // clear after loading
      WebStorage.SessionStorage.ClearQueryParams();
    }


    if (this.onlineOfflineService.isOnline) {
      const offlineMessage = document.getElementById('offlineModulo') as HTMLElement;
      if (offlineMessage) {
        offlineMessage.style.display = 'none';
      }

      this.validateContentManagementAccess().then(() => {
        if (this.allowContentFeatures) {
          this.getContentCategoryList();
          this.getContenImageUlr();
        }
      })

      this.getReminderAnnouncementList();
    }
    else {
      const offlineMessage = document.getElementById('offline') as HTMLElement;
      if (offlineMessage) {
        offlineMessage.style.display = 'block';
      }
    }

    this.getShipCrewList().then(() => {
      if (SecurityHelper.GetLoggedInUserData().roleID == Helper.Constants.RoleID.COOK) {
        this.filterShipCrewByType('Cook')
        let user = this.shipCrewList.find(x => x.isActive == true);
        if (user != null)
          this.userName = user.firstName;
      }
      if (SecurityHelper.GetLoggedInUserData().roleID == Helper.Constants.RoleID.CAPTAIN) {
        this.filterShipCrewByType('Captain')
        let user = this.shipCrewList.find(x => x.isActive == true);
        let lastChar = SecurityHelper.GetLoggedInUserData().username.slice(-3);
        if (user != null)
          this.userName = lastChar == 'Cpt' ? "Captain " + user.firstName : user.firstName;
      }
      if (SecurityHelper.GetLoggedInUserData().roleID == Helper.Constants.RoleID.CAMPBOSS) {
        this.filterShipCrewByType('Campboss')
        let user = this.shipCrewList.find(x => x.isActive == true);
        let lastChar = SecurityHelper.GetLoggedInUserData().username.slice(-2);
        if (user != null)
          this.userName = lastChar == 'Cb' ? "Campboss " + user.firstName : user.firstName;
      }
    });
  }

  private validateContentManagementAccess(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {
      this.homeService.validateContentManagementAccessByShip().subscribe((res: any) => {
        if (this.isResponseValid(res)) {
          if (res.entity.list.length > 0) {
            //this.contentFeatures = false;
            this.allowContentFeatures = false;
          } else {
            if (SecurityHelper.GetLightVersion()) {
              this.allowContentFeatures = false;
            }
          }
          resolve(true);
        }
      })
    });
    return promise;
  }

  onImageError(event:any) {
    this.unableToLoadImage = true;
  }

  routeOrderRequest() {
    this.router.navigate(['admin/orders/order-request']);
  }
  getShipManagerLogoDirectoryPath() {
    if (this.onlineOfflineService.isOnline) {
      this.securityService.getShipManagerLogoDirectoryPath().subscribe((res: any) => {
        if (res.entity.list != null) {
          let onlinePath: string = ''
          if (res.entity.list.length > 0) {
            let indx = res.entity.list[0].path.indexOf('users-files');
            onlinePath = res.entity.list[0].path;
            this.logoPath = res.entity.list[0].path.substring(indx);
            this.shipsManagerOwnerID = res.entity.list[0].shipsManagerOwnerID;
            SecurityHelper.SetShipManagerLogo(this.logoPath);
          }

          this.checkIfImageExist(onlinePath);
          this.getFeaturedContentDetailList();
        }
        else {
          this.logoPath = 'assets/images/no-image-available.png';
        }
      });
    }
    else {
      let path = SecurityHelper.GetShipManagerLogo();
      this.logoPath = path;
      this.checkIfImageExist(path);
    }
  }
  checkIfImageExist(onlinePath:any) {
    fetch(this.logoPath, { method: 'HEAD' })
      .then((res: any) => {
        if (!res.ok) {
          if (this.onlineOfflineService.isOnline) {
            this.logoPath = onlinePath;
          }
        }
      }).catch((err: any) => {
        this.logoPath = 'assets/images/no-image-available.png';
        console.log('Error:', err)
      });
  }

  getShipCrewList(): Promise<Object> {
    let promise = new Promise<Object>((resolve) => {

      if (this.onlineOfflineService.isOnline && this.onlineOfflineService.isAuthenticated) {
        this.shipCrewService.getShipCrewList().subscribe({
          next: (res: any) => {
            if (this.isResponseValid(res)) {
              //list of crew from IFSOBS
              this.allCrewList = res.entity.list;
              this.shipCrewService.saveShipCrewIndxDb(this.allCrewList);

              //include crew added offline
              this.shipCrewService.getShipCrewIndxDb("Pending").then((list: any) => {
                list.forEach((crew: ShipCrewData) => {
                  this.allCrewList.push(crew);
                });

                this.getShipCrewTypeList();
                this.filterShipCrewByType("All");
                resolve(res.entity.list);
              });
            }
          },
          error: (err: any) => {
          }
        });
      } else {
        this.shipCrewService.getShipCrewIndxDb("All").then((list: any) => {
          this.allCrewList = list;
          this.getShipCrewTypeList();
          this.filterShipCrewByType("All");
          resolve(list);
        });
      }

    });
    return promise;
  }

  filterShipCrewByType(filter: string) {
    switch (filter) {
      case "All":
        this.shipCrewList = this.allCrewList;
        break;
      case "Captain":
        this.shipCrewList = this.captainList;
        break;
      case "Campboss":
        this.shipCrewList = this.campbossList;
        break;
      case "Cook":
        this.shipCrewList = this.cookList;
        break;
    }
  }
  getShipCrewTypeList() {
    this.allCrewList.forEach((crew: ShipCrewData) => {
      switch (crew.crewSubTypeID) {
        case Helper.Constants.CrewSubTypeID.CAPTAIN: //Captain
          this.captainList.push(crew);
          break;
        case Helper.Constants.CrewSubTypeID.COOK: //Cook
          this.cookList.push(crew);
          break;
        case Helper.Constants.CrewSubTypeID.CAMPBOSS: //Campboss
          this.campbossList.push(crew);
          break; }
    });
  }

  getContentCategoryList() {
    this.homeService.getContentCategoryList('ALL').subscribe(
      (res: any) => {
        if (this.isResponseValid(res)) {
          this.contentCategoryList = res.entity.list;
        }
      }
    )
  }

  getContenImageUlr() {
    this.homeService.getContentPhotoUrl().subscribe(
      (res: any) => {
        if (this.isResponseValid(res)) {
          this.contentImageFileUrl = res.entity.value;
        }
      }
    )
  }

  getReminderAnnouncementList() {
    this.homeService.getContentReminderList('1').subscribe(
      (res: any) => {
        if (this.isResponseValid(res)) {
          this.ReminderAnnouncement = res.entity.list;

          let tmp = this.ReminderAnnouncement.filter(e => this.isSelectedShipOrManager(e.shipID, this.shipId) || e.shipID == null || e.shipID == '' || this.isSelectedShipOrManager(e.shipsManagerOwnerID, this.shipsManagerOwnerID));
          this.ReminderAnnouncement = tmp;
        }
      }
    )
  }

  getContentDetailList(categoryID:any) {
    this.contenDetailList = [];
    this.contenDetail = new ContentDetailData();
    this.homeService.getContentDetailList(categoryID).subscribe(
      (res: any) => {
        let seq = 0;
        if (this.isResponseValid(res)) {
          if (res.entity.list.length > 0) {

            this.contenDetailList = res.entity.list;
            let tmpContentDataList: ContentDetailData[] = [];

            //this.contenDetailList = tmpContentDataList;                       
            this.contenDetailList.forEach(x => {
              if (((x.shipID == null || x.shipID == '') && (x.shipsManagerOwnerID == null || x.shipsManagerOwnerID == '')) || this.isSelectedShipOrManager(x.shipID, this.shipId) || this.isSelectedShipOrManager(x.shipsManagerOwnerID, this.shipsManagerOwnerID)) {
                //x.seq = seq;
                //if (seq == 0)
                //  seq = 1
                //else
                //  seq = 0;
                tmpContentDataList.push(x);
              }
            });
            this.contenDetailList = [];
            this.contenDetailList = tmpContentDataList;
            if (this.contenDetailList.length > 0)
              this.getContentDetail(this.contenDetailList[0].contentDetailID);

          }
        }
      }
    )
  }

  isSelectedShipOrManager(shipOrManager:any, currShipOrManager:any): Boolean {
    let ret: Boolean = false;

    let arrTemp = DataFormatter.makeNumArray(shipOrManager);

    if (arrTemp.length > 0) {
      let tmp = arrTemp.find(x1 => x1 == currShipOrManager)
      if (tmp != null) {
        ret = true;
      }
    }
    return ret;
  }
  getFeaturedContentDetailList() {
    if (this.contentFeatures) {
      this.contenFeatureDetailList = [];
      this.contenDetail = new ContentDetailData();
      this.homeService.getFeturedContentDetailList().subscribe(
        (res: any) => {
          let seq = 0;
          this.contenDetailList = [];
          if (this.isResponseValid(res)) {
            if (res.entity.list.length > 0) {

              let contenDetailList = res.entity.list;
              this.contenDetailList = res.entity.list;
              let tmpContentDataList: ContentDetailData[] = [];

              this.contenDetailList.forEach(x => {
                if (((x.shipID == null || x.shipID == '') && (x.shipsManagerOwnerID == null || x.shipsManagerOwnerID == ''))
                  || this.isSelectedShipOrManager(x.shipID, this.shipId)
                  || this.isSelectedShipOrManager(x.shipsManagerOwnerID, this.shipsManagerOwnerID)) {

                  tmpContentDataList.push(x);
                }
              })

              //this.contenFeatureDetailList = tmpContentDataList.filter((item, index, self) => index === self.findIndex(i => i.contentCategoryID === item.contentCategoryID));
              this.contenFeatureDetailList = (tmpContentDataList.slice(0, 4)).sort((a, b) => a.sequence - b.sequence);; 
            }
          }
        }
      )
    }
  }

  getContentLayout(contentDetail: ContentDetailData): string {
    let layout = 'py-3 ';
    switch (contentDetail.spanColumnCount) {
      case 4:
        layout += 'col-12';
        break;
      case 3:
        layout += 'col-9';
        break;
      case 2:
        layout += 'col-6';
        break;
      case 1:
        layout += 'col-3';
        break;
    }
    return layout
  }

  getContentDetail(contentDetailID:any) {
    this.homeService.getContentDetail(contentDetailID).subscribe(
      (res: any) => {
        let seq = 0;
        if (this.isResponseValid(res)) {
          if (res.entity.list.length > 0) {

            this.contenDetail = res.entity.list[0];          

            this.createLogs(Helper.Constants.DailyLogs.Forms.HOME
              , Helper.Constants.DailyLogs.Actions.PAGE_VIEW
              , Helper.Constants.DailyLogs.Results.SUCCESSFUL
              , "IVI View " + this.contenDetail.title
              , Helper.Constants.DailyLogs.MainTableNames.CONTENT_DETAILS
            )

            this.contenDocumentList = [];
            this.homeService.getContentDocumentList(contentDetailID).subscribe(
              (res: any) => {
                let seq = 0;
                if (this.isResponseValid(res)) {
                  if (res.entity.list.length > 0) {
                    this.contenDocumentList = res.entity.list;
                  }
                }
              }
            )
          }
        }
      }
    )
  }


  getContentDocumentList(contentDetilID:any) {
    if (this.contenDocumentList.length > 0) {
      let path = this.downloadUrl(this.contenDocumentList[0].docFileName);
      window.open(path);
    }
  }

  displayContentDetailList(item:any) {

    if (item) {
      this.contentFeatures = false;
      this.contentDisplayMore = false;
      this.getContentDetailList(item.contentCategoryID.toString())
    }
  }

  displayContentDetail(item:any) {

    if (item) {
      this.contentFeatures = false;
      this.getContentDetail(item.contentDetailID.toString())
    }
  }

  displayDetailDownload(item:any) {
    if (item) {
      this.getContentDocumentList(item.contentDetailID.toString())

    }
  }

  displayViewMore(item:any) {
    if (item) {
      this.contentFeatures = false;
      this.contentDisplayMore = true;
      this.getContentDetail(item.contentDetailID.toString())
    }
  }
  displayFeatures() {
    this.contentFeatures = true;
    this.contentDisplayMore = false;
    // force reload page
    // Note: Navigating to same url will not reload the component. Workaround fix, navigate to a diff url first.
    this.router.navigateByUrl('/admin/home/content', { skipLocationChange: true }).then(() => {

      this.router.navigate(['/admin/home']);
    });
  }
  imageUrl(fileName: any): string {
    let path: string;
    path = this.contentImageFileUrl + fileName;

    if (fileName == null || fileName == '')
      path = 'assets/images/no-image-available.png'

    return path;
  }
  setBackgroundStyle(bgColor: any): string {
    let style = 'background-color:' + bgColor + ';';
    return style;
  }
  downloadUrl(fileName: any): string {

    let path: string;
    path = this.contentImageFileUrl + fileName;
    return path;
  }

  isResponseValid(res: any): boolean {
    let isValid = true;

    if (res.errorMessage.length > 0) {
      isValid = false;
      this.handleError(res.errorMessage[0]);
    }
    else {
      // reset API retry count
      this.countAPIRetry = 0;
    }

    return isValid;
  }
  handleError(error: any) {
    let errorTitle = error.name ? error.name : 'Error';
    let errorMessage = error.message ? error.message : JSON.stringify(error);

    swal.fire({
      title: errorTitle,
      html: '<span>' + errorMessage + '</span>',
      icon: "error",
      showCloseButton: true,
      allowOutsideClick: false,
      allowEscapeKey: false
    });
    // reset API retry count
    this.countAPIRetry = 0;
  }

  getClassName(clsName: any): string {

    var className: string;

    if (clsName != null)
      className = clsName + ' icon-only';
    else
      className = '';

    return className;

  }
  private createLogs(form: string, action: string, result: string, systemRemarks: string, mainTableNames: string) {
    const userID = SecurityHelper.GetLoggedInUserData().userID;
    this.dailyLogsService.createDailyLogs(form, action, result, systemRemarks, mainTableNames,"", userID).subscribe();
  }
}
